import { render } from "./ImageTags.vue?vue&type=template&id=3f9689e9&scoped=true"
import script from "./ImageTags.vue?vue&type=script&lang=js"
export * from "./ImageTags.vue?vue&type=script&lang=js"

import "./ImageTags.vue?vue&type=style&index=0&id=3f9689e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9689e9"]])

export default __exports__